module.exports = __webpack_public_path__ + "static/media/carousel-3.a55430e7.jpg";